import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokLink } from "@/storyblok";

export const LinkBlok = ({ blok }: BlokProps<BlokLink>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<Button href={sbLink(blok.href)?.href ?? "#"}>{blok.text}</Button>
		</BlokWrap>
	);
};
